import { useActionButtonContext } from '@aibees/elephant/context/action-button-context';
import { RowSelectionPopupMaxPeople } from '@aibees/elephant/feature/search-table-people/components/row-selector-popup-max-people';
import {
  useSearchTableFromRoute,
  useUpdateActionSelectedIds,
} from '@aibees/elephant/hooks';
import { useSearchTableTabs } from '@aibees/elephant/hooks/use-search-table-tabs';
import { SearchTable } from '@aibees/elephant/types';
import { AdvancedTableSelectionPopover } from '@aibees/shared/features';
import { classnames } from '@aibees/shared/utils';
import { Divider } from '@mui/material';
import { memo } from 'react';
import { SearchModality } from '../../hooks/types';
import { SearchTableHeaderActions } from '../search-table-header-actions';
import * as Styled from './styles';
import type { SearchTableHeaderActionsProps as Props } from './types';

export const SearchTableHeader = memo(
  ({ className, children, sx, table, data, isSmall, extraActions }: Props) => {
    const { tab } = useSearchTableTabs();
    const { item } = useActionButtonContext();
    useUpdateActionSelectedIds(table, item?.id);
    const tableType = useSearchTableFromRoute();

    return (
      <Styled.Wrapper
        className={classnames('SearchTableHeader', className)}
        sx={sx}
        direction="row"
      >
        <Styled.StartContainer>
          <AdvancedTableSelectionPopover
            key={tab} // force re-render when tab changes
            table={table}
            data={data}
            additionalContent={
              tableType === SearchTable.People ||
              tableType === SearchTable.Employees ? (
                <RowSelectionPopupMaxPeople />
              ) : undefined
            }
          />

          <Divider orientation="vertical" flexItem />
          {extraActions}
          <SearchTableHeaderActions
            table={table}
            compact={isSmall}
            activeTab={tab as SearchModality}
          />
        </Styled.StartContainer>
        <Styled.EndContainer>{children}</Styled.EndContainer>
      </Styled.Wrapper>
    );
  }
);

SearchTableHeader.displayName = 'SearchTableHeader';
